// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3YMNA","overflowing":"ReadFullNote_overflowing__2YYV9"};